// Permission area

export const PermissionArea = {
    // Management
    UserManagement: 'UserManagement',
    RoleManagement: 'RoleManagement',

    // Modules
    InteractionModule: 'InteractionModule',
    QualityAssuranceModule: 'QualityAssuranceModule',
    DashboardModule: 'DashboardModule',
    AskMeModule: 'AskMeModule',
} as const;

/** Permissions shown in role and user settings. Anything not listed here stays hidden. */
export const VisiblePermissions: readonly string[] = [
    PermissionArea.UserManagement,
    PermissionArea.RoleManagement,
    PermissionArea.InteractionModule,
    PermissionArea.QualityAssuranceModule,
    PermissionArea.DashboardModule,
    PermissionArea.AskMeModule,
];

// Level of permission

export const UserManagementPermissionFlag = {
    None: 0,
    Access: 1,
} as const;

export const RoleManagementPermissionFlag = {
    None: 0,
    Access: 1,
} as const;

export const InteractionModulePermissionFlag = {
    None: 0,
    Access: 1,
    Streaming: 4,
    SentimentPercentage: 8,
    SentimentLevelInteraction: 16,
    SentimentLevelTextSegment: 32,
    SentimentDirectionPerInteraction: 64,
} as const;

export const QualityAssuranceModulePermissionFlag = {
    None: 0,
    Access: 1,
    ManualCoaching: 4,
    CreateForm: 8,
    ScheduleCoaching: 16,
    AICoaching: 32,
    ApproveProtocols: 64,
    RestrictedComment: 128,
    EditAiCoach: 256,
    EditManualCoach: 512,
} as const;

export const DashboardModulePermissionFlag = {
    None: 0,
    ViewDashboards: 1,
    ManageDashboards: 2,
    ShareWithUsers: 4,
    ShareUrl: 8,
    ExportAsPdf: 32,
    Schedule: 64,
    ShareWithRoles: 128,
} as const;

export const AskMeModulePermissionFlag = {
    None: 0,
    Access: 1,
    MiniAskMe: 4,
} as const;
